import React from 'react'

const PurpleHeading = ({purpleHeadingText}) => {
  return (
    <>
     <div className='purpleHeading'>{purpleHeadingText}</div>
    </>
  )
}

export default PurpleHeading